export const redirectUserTo = (url: string) => {
  window.location.href = url
}
